export default __webpack_public_path__ + "static/media/newslider2.19bfb6de.jpg";